export const MsgImagePreviewContent = memo(function MsgImagePreviewContent() {
  const { t } = useTranslation();
  return `[${t('chat.photoText')}]`;
});
